import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { StateService } from '../services/state.service'

export const introGuard: CanActivateFn = (route, state) => {
  const stateService = inject(StateService)
  const router = inject(Router)

  if (stateService.targetGroup()) {
    return true
  }

  const lang = stateService.currentLanguage()
  if (lang && ['au', 'sv'].includes(lang)) {
    return true
  }

  if (state.url === '/intro') {
    return true
  }

  if (!router.navigated && (state.url.includes('/article/') || state.url.includes('/page/'))) {
    return true
  }

  return router.createUrlTree(['/intro'], { queryParams: route.queryParams })
}
